export function isEmpty(object: object) {
  for (const prop in object) {
    if (object.hasOwnProperty(prop)) {
      return false;
    }
  }
  return true;
}
